module.exports = __webpack_public_path__ + "static/img/s_course_bg.0ec7b755.png";